import { useEffect, useRef, useState } from "react";
import { useSites } from "../lib/sites";
import type { Lang } from "../lib/prefs";

const T = {
  es: { pick: "Elegir sitio", newSite: "＋ Nuevo sitio", sites: "Sitios" },
  en: { pick: "Select site", newSite: "＋ New site", sites: "Sites" },
};

// The topbar site selector: lists the caller's sites, marks the active one, and
// offers "＋ Nuevo sitio". Selection is persisted via SitesContext.
export default function SiteSelector({
  lang,
  onNewSite,
}: {
  lang: Lang;
  onNewSite: () => void;
}) {
  const t = T[lang];
  const { sites, selectedSite, selectSite } = useSites();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="topwrap" ref={ref}>
      <button
        className="sel"
        aria-label={T[lang].sites}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        {selectedSite ? selectedSite.domain : t.pick} <span className="car">▾</span>
      </button>
      {open && (
        <div className="drop left site-drop" role="listbox">
          <div className="drop-h">{t.sites}</div>
          {sites.map((s) => (
            <button
              key={s.id}
              className={`site-item${selectedSite?.id === s.id ? " on" : ""}`}
              role="option"
              aria-selected={selectedSite?.id === s.id}
              onClick={() => {
                selectSite(s.id);
                setOpen(false);
              }}
            >
              <span className="d">{s.domain}</span>
              <span className={`plan-tag ${s.plan}`}>{s.plan}</span>
            </button>
          ))}
          <button
            className="site-item new"
            onClick={() => {
              setOpen(false);
              onNewSite();
            }}
          >
            {t.newSite}
          </button>
        </div>
      )}
    </div>
  );
}
